import React from 'react';
import PanelsTab from './PanelsTab';
import useExpDetailsSelectedTemplate from '@experiment-details/hooks/useExpDetailsSelectedTemplate';
import { SmallLoader } from '@shared';
import { ExperimentDetails } from '@shared/types';

type PanelsTabWrapperProps = {
  experiments: ExperimentDetails[];
};
const PanelsTabWrapper: React.FC<PanelsTabWrapperProps> = ({ experiments }) => {
  const {
    templateData,
    isLoading: isTemplateDataLoading
  } = useExpDetailsSelectedTemplate();

  if (isTemplateDataLoading || !templateData) {
    return <SmallLoader />;
  }

  return <PanelsTab experiments={experiments} />;
};

export default PanelsTabWrapper;
